import axios from '@/libs/api.request'

/**
 * 接口权限列表
 */
export const interfaceList = (access_token_id) => {
    let data = {
        'access_token_id': access_token_id
    }
    return axios.request({
        url: '/api/admin/accesstoken/interfaceList',
        data,
        method: 'post'
    })
}

/**
 * 保存接口权限
 */
 export const saveInterface = (access_token_id, ids) => {
    let data = {
        'access_token_id': access_token_id,
        'ids': ids
    }
    return axios.request({
        url: '/api/admin/accesstoken/saveInterface',
        data,
        method: 'post'
    })
}
